import React, { FC } from 'react';
import cls from './WeeksMode.module.css';
import classNames from 'classnames';
import { WeeksModeHeader } from './WeeksModeHeader/WeeksModeHeader';
import { WeeksModeBody } from './WeeksModeBody/WeeksModeBody';
export const WeeksMode = ({ stages, classes, isBlur }) => {
    return (
        <div className={classNames(cls.WeeksMode, { [classes]: isBlur })}>
            <WeeksModeHeader />
            <WeeksModeBody stages={stages} />
        </div>
    );
};
